import { Getters } from 'vuex-smart-module';
import NewRepairState from './state';

export default class NewRepairGetters extends Getters<NewRepairState> {}
